/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { DtmKadDocCreateRequest } from '../types/DtmKadDocCreate';
import type { DtmKadDocCreateResponse } from '../types/DtmKadDocCreate';

export type DtmKadDocsCheckDmvsPendingPozadavkyCreateRequest = DtmKadDocCreateRequest;
export type DtmKadDocsCheckDmvsPendingPozadavkyCreateResponse = DtmKadDocCreateResponse;

export type DtmKadDocsCheckDmvsPendingPozadavkyCreateQuery = {};

/**
 * POST /dmx-server/dtm_kad_docs/check_dmvs_pending_pozadavky/
 *
 * ```yaml
 * operationId: dtm_kad_docs_check_dmvs_pending_pozadavky_create
 * tags:
 *   - dtm_kad_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/DtmKadDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/DtmKadDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/DtmKadDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DtmKadDocCreate'
 *     description: ''
 * ```
 */
export const dtmKadDocsCheckDmvsPendingPozadavkyCreateOperation = (
  rest?: DtmKadDocsCheckDmvsPendingPozadavkyCreateQuery | null,
) =>
  ({
    method: 'POST',
    path: `/dmx-server/dtm_kad_docs/check_dmvs_pending_pozadavky/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/dtm_kad_docs/check_dmvs_pending_pozadavky/' };
  };

/**
 * POST /dmx-server/dtm_kad_docs/check_dmvs_pending_pozadavky/
 *
 * ```yaml
 * operationId: dtm_kad_docs_check_dmvs_pending_pozadavky_create
 * tags:
 *   - dtm_kad_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/DtmKadDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/DtmKadDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/DtmKadDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DtmKadDocCreate'
 *     description: ''
 * ```
 */
export const dtmKadDocsCheckDmvsPendingPozadavkyCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: DtmKadDocsCheckDmvsPendingPozadavkyCreateQuery;
  request: DtmKadDocCreateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<DtmKadDocCreateResponse>> => {
  const operation = dtmKadDocsCheckDmvsPendingPozadavkyCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
